import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  { label: 'S.N', value: 'id' },
  {
    label: 'Badge name',
    value: 'badge[badgeName]',
  },
  {
    label: 'Code',
    value: 'badge[badgeCode]',
  },
  {
    label: 'Color',
    value: 'badge[badgeColor]',
  },

  {
    label: 'Description',
    value: 'description',
  },

  {
    label: 'Badge',
    value: 'incentiveBadgeImage',
  },
  {
    label: 'Banner',
    value: 'incentiveBannerImage',
  },
  {
    label: 'Amount',
    value: 'amount',
  },
  // {
  //   label: 'Start date',
  //   value: 'start',
  // },
  // {
  //   label: 'End date',
  //   value: 'end',
  // },
  /*  {
    action: ['view_certificate'],
  }, */
  {
    action: ['edit'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
